<div class="mb-3">
  <app-summary [model$]="model$" [summaryItems]="summaryItems.bind(this)"></app-summary>
</div>

<div class="mb-3">
  <div class="row">
    <div class="col-xl-6">
      <app-tab-grid
        i18n-header
        header="Requirements"
        gridCssClass="purchase-order-requirement-grid"
        [additionalFields]="additionalFields"
        [columnDefs]="columnDefsRequirements"
        [multiSelectRows]="false"
        [pagination]="false"
        [rowData]="purchaseOrderLineRequirements$ | async"
        [showExport]="false"
        (create)="create()"
        (delete)="delete($event)"
        (rowSelected)="rowRequirementSelected($event)"
      ></app-tab-grid>
    </div>
    <div class="col-xl-6">
      <app-tab-grid
        i18n-header
        header="Purchase Orders to Allocate"
        gridCssClass="purchase-order-requirement-grid"
        [columnDefs]="columnDefsPurchaseOrders"
        [pagination]="false"
        [rowData]="purchaseOrdersToAllocate$ | async"
        [showCreate]="false"
        [showDelete]="false"
        [showExport]="false"
        (delete)="deletePoAllocation($event)"
        (rowSelected)="rowPurchaseOrderSelected($event)"
      ></app-tab-grid>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-xl-6">
    <app-tab-grid
      i18n-header
      header="Stock to Allocate"
      gridCssClass="purchase-order-stock-allocation-grid"
      [columnDefs]="columnDefsStock"
      [pagination]="false"
      [rowData]="stockToAllocate$ | async"
      [showCreate]="false"
      [showDelete]="false"
      [showExport]="false"
      (rowSelected)="rowAllocationSelected($event)"
    ></app-tab-grid>
  </div>
  <div class="col-xl-6">
    <app-tab-grid
      i18n-header
      header="Issued Stock"
      gridCssClass="purchase-order-stock-allocation-grid"
      stateKey="PurchaseOrderLineRequirementsIssuedStock"
      [columnDefs]="columnDefsIssues"
      [pagination]="false"
      [rowData]="issuedStock$ | async"
      [showCreate]="false"
      [showDelete]="false"
      [showExport]="false"
    ></app-tab-grid>
  </div>
</div>
